// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__23cnf","wrapper":"Modal_wrapper__3kONS","noMinWidth":"Modal_noMinWidth__1xXv7"};